import { useEffect } from 'react';

/**
 * [공통] 스크롤 등장 애니메이션.
 * .reveal 요소가 뷰포트에 15% 이상 들어오면 .in을 붙여 페이드인시키고,
 * 한 번 나타난 뒤에는 관찰을 해제(unobserve)해 불필요한 연산을 막는다.
 *
 * 원본 index.html은 document 전체에서 `.reveal`을 한 번에 찾았다. 이 페이지는 섹션마다
 * 컴포넌트가 나뉘어 있어, HomePage.jsx가 마운트를 마친 뒤(모든 자식 섹션이 렌더링된 뒤)
 * 이 훅을 한 번만 호출해 문서 전체의 reveal 요소를 관찰하면 원본과 동일하게 동작한다.
 *
 * @param {string} revealClass - CSS Module이 생성한 .reveal 클래스의 실제(해시) 이름
 * @param {string} inClass - CSS Module이 생성한 .in 클래스의 실제(해시) 이름
 */
export default function useRevealOnScroll(revealClass, inClass) {
  useEffect(() => {
    if (!revealClass || !inClass) return undefined;
    const els = Array.from(document.getElementsByClassName(revealClass));
    if (!els.length) return undefined;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(inClass);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    els.forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, [revealClass, inClass]);
}
